import * as mutations from './mutations'

export const Authorization = {
  mutations: {
    ...mutations
  }
}
